import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    helperText: {
        position: 'absolute',
        top: '35px',
    },
    inputContainer: {
        width: '100%',
        position: 'relative',
    },
}));
